import type { TFunction } from "i18next";

import type { WorkItem } from "shared/api/types";

/** Round 16 I13 -- a title the server composed renders from its key;
 *  a record's own name is not a string to translate. Round 18 I18 --
 *  shared, so the home pages read it as My Work does. */
export function itemTitle(t: TFunction, item: WorkItem): string {
  return item.title_key ? t(item.title_key, { defaultValue: item.title }) : item.title;
}
